let mktoConf = {
    targetNode: '#iframeTarget1',
    //thankYouPage: '',
    //landingPageUrl: 'https://pages.autodesk.com/uData.html',
    singleColumn: false,
    infieldLabels: false,
    formLang: "en-us",
    activityId: "4348830005",
    activityName: '4348830_D&M_Landing Form - Personal Page US',
    programId: "000000",
    programName: 'Always On: Fusion 360',
    formId: "8454",
    landingPageId: '16646',
    communicationChannel: 'CONTACT',
    leadType: '',
    bypassMRF: true,
    productInterests: 'F360',
    submitLabel: 'NEXT',
    onSuccessURL: 'https://www.autodesk.com/products/fusion-360/personal-download',
    mktvar001: ((marketoAEM.methods.getQstring()['mktvar001']) ? marketoAEM.methods.getQstring()['mktvar001'] : ((marketoAEM.methods.getCookie('mktvar001')) ? marketoAEM.methods.getCookie('mktvar001') : '')),
    mktvar002: ((marketoAEM.methods.getQstring()['mktvar002']) ? marketoAEM.methods.getQstring()['mktvar002'] : ((marketoAEM.methods.getCookie('mktvar002')) ? marketoAEM.methods.getCookie('mktvar002') : '')),
    mktvar004: ((marketoAEM.methods.getQstring()['mktvar004']) ? marketoAEM.methods.getQstring()['mktvar004'] : ((marketoAEM.methods.getCookie('mktvar004')) ? marketoAEM.methods.getCookie('mktvar004') : '')),
    resellerId: ((marketoAEM.methods.getQstring()['rid']) ? marketoAEM.methods.getQstring()['rid'] : ((marketoAEM.methods.getCookie('rid')) ? marketoAEM.methods.getCookie('rid') : '')),
    // Labels and select labels, underneath here are getting overwritten by content in the divs from the text component above this code component
    customFields: {
        'Phone': {
            insertAfter: 'PostalCode',
            label: 'Phone',
            type: 'text',
            required: true
        },
        'Company': {
            type: 'hidden',
            value: 'none',
            required: false
        },
        'text': {
            insertAfter: "homePhone",
            label: 'What do you primarily plan to use Fusion 360 for?',
            type: 'select',
            required: true,
            data: {
                "CAM": "CAM",
                "Industrial Design": "Industrial Design",
                "Mechanical Engineering": "Mechanical Engineering",
                "3D Modeling": "3D Modeling",
                "Electronics": "Electronics Engineering"
            }
        }
    },
    fieldList: "FirstName,LastName,Email,Company,Country,State,PostalCode,Phone,text,Unsubscribed,privacycb"
}
function wp_mktoForm(){
    marketoAEM.methods.init(mktoConf);
}
if (document.readyState !== 'loading') { wp_mktoForm(); }
else if (document.addEventListener) { document.addEventListener('DOMContentLoaded', wp_mktoForm); }
else { document.attachEvent('onreadystatechange',function(){ if (document.readyState === 'complete') { wp_mktoForm(); } }); }

if (!document.body.hasAttribute('data-author-mode')) {
    window.addEventListener("SSO_SIGNED_OUT", () => { window.location.href = "https://www.autodesk.com/products/fusion-360/personal" });
}


